interface HourlyData {
  hour: string;
  count: number;
}

interface HourlyChartProps {
  data: HourlyData[];
}

export default function HourlyChart({ data }: HourlyChartProps) {
  const max = Math.max(...data.map((d) => d.count), 1);

  return (
    <div className="bg-white dark:bg-stone-900 rounded-xl border border-stone-100 dark:border-stone-800 p-5">
      <h3 className="text-sm font-semibold text-stone-700 dark:text-stone-300 mb-4 flex items-center gap-2">
        <i className="ri-bar-chart-2-line text-emerald-500" /> Pageviews — Last 24 Hours
      </h3>
      <div className="flex items-end gap-1 h-32">
        {data.map((d) => {
          const heightPct = Math.round((d.count / max) * 100);
          return (
            <div key={d.hour} className="flex-1 flex flex-col items-center gap-1 group relative">
              <div
                className="w-full bg-rose-200 dark:bg-rose-900 rounded-sm transition-all duration-300 group-hover:bg-rose-400 dark:group-hover:bg-rose-500"
                style={{ height: `${Math.max(heightPct, 2)}%` }}
              />
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-stone-800 text-white text-xs rounded px-1.5 py-0.5 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10">
                {d.count} views
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex justify-between mt-2">
        <span className="text-xs text-stone-400">{data[0]?.hour ?? ''}</span>
        <span className="text-xs text-stone-400">{data[data.length - 1]?.hour ?? ''}</span>
      </div>
    </div>
  );
}
